import React, { Fragment, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { clearBatch } from "state/reducers/smsBatching";
import logo from "assets/logo_black.svg";
import card from "assets/marketing_dashboard/test-card.png";
import MarketingContainer from "./utils/components/MarketingContainer";
import MarketingNavigation from "./utils/components/MarketingNavigation";
import "./utils/styles/marketing-dashboard.css";

const Marketing = () => {
  const completed = useSelector(state => state.smsBatching.completed);
  const dispatch = useDispatch();
  useEffect(() => {
    if (completed) {
      dispatch(clearBatch());
    }
  }, []);
  return (
    <Fragment>
      <MarketingContainer>
        <MarketingNavigation />
        <div className="my-auto items-center mx-auto justify-center bg-transparent rounded-lg">
          <img
            src={logo}
            style={{ width: "auto", height: 35 }}
            className="w-1/2 mx-auto my-5"
            alt="TomoCredit White Logo"
          />
          <h1 className="text-2xl font-normal py-1 font-light text-center ">
            Marketing Dashboard
          </h1>
          <img
            src={card}
            alt="TomoCredit Card"
            className="mx-auto"
            style={{ maxWidth: "25%" }}
          />
        </div>
      </MarketingContainer>
    </Fragment>
  );
};

export default Marketing;
